import { TwcProduct } from '../../../twc-products';

export const WINTER_RADAR_OVERLAY_PRODUCT_DATA: TwcProduct = {
  id: 'radar-mosaic-with-winter-overlay',
  defaultProductId: 'radarMosaic-boeing',
  productName: 'Weather-RadarMosaic-TWC',
  label: 'Radar Mosaic with Winter Overlay',
  weatherType: 'RADAR',
  description: 'TWC product (raster) - Global Radar Mosaic with Winter Overlay',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 9,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85
};
